import { useEffect } from "react";
import { useCheckBooleanSetting } from "../contexts/SettingsContext";

function useDisableDevTools() {
    const disableDevTools = useCheckBooleanSetting('DISABLE_DEVTOOLS');

    useEffect(() => {

        if (!disableDevTools) return;

        const handleContextMenu = (e) => {
            e.preventDefault();
        };

        const handleKeyDown = (e) => {
            const key = e.key.toLowerCase();

            // F12
            if (key === "f12") {
                e.preventDefault();
            }

            // Windows: Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C
            if (e.ctrlKey && e.shiftKey && ["i", "j", "c"].includes(key)) {
                e.preventDefault();
            }

            // Mac: Cmd+Option+I / Cmd+Option+J / Cmd+Option+C
            if (e.metaKey && e.altKey && ["i", "j", "c"].includes(key)) {
                e.preventDefault();
            }

            // Mac: Cmd+Shift+C
            if (e.metaKey && e.shiftKey && key === "c") {
                e.preventDefault();
            }
        };

        document.addEventListener("contextmenu", handleContextMenu);
        document.addEventListener("keydown", handleKeyDown);

        // Function toString trick: Chrome DevTools calls toString() on a
        // function when rendering its source preview in the console.
        // Unlike Proxy traps (which Chrome intentionally bypasses for DevTools
        // introspection), the JavaScript toString() override is called normally.
        // When DevTools is closed, console.log is a no-op and toString is
        // never called.
        let fnDetected = false;
        const fnProbe = function devtoolsProbe() { };
        fnProbe.toString = () => {
            fnDetected = true;
            return "function devtoolsProbe() {}";
        };

        const blockDevTools = () => {
            document.body.innerHTML = `
                <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif;text-align:center;">
                    <h1 style="font-size:2rem;margin-bottom:0.5rem;">DevTools is not allowed.</h1>
                    <p style="font-size:1.1rem;color:#555;">Close DevTools and refresh to see the website.</p>
                </div>
            `;
            document.body.style.margin = "0";
        };

        const interval = setInterval(() => {
            // Method 1: Dimension check — catches docked DevTools (including
            // device toolbar / mobile simulation when DevTools is docked).
            const threshold = 160;
            if (
                window.outerHeight - window.innerHeight > threshold ||
                window.outerWidth - window.innerWidth > threshold
            ) {
                blockDevTools();
                return;
            }

            // Method 2: debugger timing — catches undocked DevTools when
            // breakpoints are active. CDP pauses execution from a separate
            // window, making elapsed time jump from ~0ms to 100ms+.
            const dbgStart = performance.now();
            // eslint-disable-next-line no-debugger
            debugger;
            if (performance.now() - dbgStart > 100) {
                blockDevTools();
                return;
            }

            // Method 3: function toString — Chrome DevTools calls toString()
            // on a function to render its source preview in the console.
            // Unlike Proxy traps (which Chrome bypasses), this JS override
            // fires normally. When DevTools is closed, console.log is a
            // // no-op and toString is never called.
            // fnDetected = false;
            // console.log(fnProbe);
            // console.clear();
            // if (fnDetected) {
            //     blockDevTools();
            // }
        }, 500);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
            document.removeEventListener("keydown", handleKeyDown);
            clearInterval(interval);
        };
    }, [disableDevTools]);
}

export default useDisableDevTools;
